<div class="wk-message-dialog">
  <div class="header">
    <h3>{{data?.headerLabel}}</h3>
    <span class="close-btn-container">
      <button class="mat-icon-button" (click)="close(false)">
        <span class="wk-icon-filled-close" aria-hidden="true"></span>
      </button>
    </span>
  </div>
  <div class="body">
    <p [innerHTML]="data.message | safeHtml"></p>
  </div>
  <div class="footer">
    <button
      type="button"
      class="wk-button"
      [ngClass]="data?.cancelLabelClass||'wk-button-danger'"
      *ngIf="data?.cancelLabel"
      (click)="close(false)"
    >
      {{ data?.cancelLabel }}
    </button>
    <button
      *ngIf="data?.okLabel"
      type="button"
      class="wk-button"
      [ngClass]="data?.okLabelClass||'wk-button-primary'"
      (click)="close(true)"
    >
      {{data?.okLabel}}
    </button>
  </div>
</div>
